import { FC, useCallback, useRef, useState } from "react"
import { Modal } from "../../features/Modal/Modal"
import writeXlsxFile from "write-excel-file"
import { ISupply } from "../../app/reducers/ordersReducer"
import { SHOP_NAME } from "@acc/shared"
import { saveAuditFormOrderWB } from "../../utils/auditFormOrder"
import { Button } from "@radix-ui/themes"
import { DataTable, type DataTableColumn } from "../DataTable/DataTable"

export type RecodeForOrderSamson = {
  article: number
  quantity: number
}

export type MissOrderSamson = {
  goodCode: string
  nmId: number
}

type FormSamsonOrderProps = {
  isDisabled?: boolean
  getOrdersForSamson: () => Promise<{
    recodeForOrderSamson: RecodeForOrderSamson[]
    missOrders: MissOrderSamson[]
    info?: {
      name: string
      value: string
      count: number
      date: string
    }[]
  }>
  supplies: ISupply[]
}

const RECODE_FOR_ORDER_SCHEMA = [
  {
    column: "Коды товара",
    value: (item: RecodeForOrderSamson) => item.article,
  },
  {
    value: () => "",
  },
  {
    column: "Количество товаров",
    value: (item: RecodeForOrderSamson) => item.quantity,
  },
]

const downloadRecode = (data: RecodeForOrderSamson[], fileName?: string) => {
  return writeXlsxFile(data, {
    schema: RECODE_FOR_ORDER_SCHEMA,
    fileName: (fileName && fileName + ".xlsx") || "order_samson.xlsx",
  })
}

export const FormSamsonOrder: FC<FormSamsonOrderProps> = ({
  isDisabled,
  getOrdersForSamson,
  supplies,
}) => {
  const [isOpenModalFormOrders, setIsOpenModalFormOrders] = useState(false)
  const missOrdersRef = useRef<MissOrderSamson[]>([])
  const ordersSamsonRef = useRef<RecodeForOrderSamson[]>([])
  const infoRef = useRef<
    {
      name: string
      value: string
      count: number
      date: string
    }[]
  >([])
  const fileName = supplies?.map((supply) => supply.name).join(", ")

  const onClickFormOrderSamson = useCallback(() => {
    getOrdersForSamson().then(({ recodeForOrderSamson, missOrders, info }) => {
      missOrdersRef.current = missOrders || []
      ordersSamsonRef.current = recodeForOrderSamson || []
      infoRef.current = info || []
      setIsOpenModalFormOrders(true)
    })
  }, [getOrdersForSamson])

  return (
    <div>
      <Button disabled={isDisabled} onClick={onClickFormOrderSamson}>
        Сформировать файл для заказа Samson
      </Button>

      <Modal
        isOpen={isOpenModalFormOrders}
        onClose={() => {
          setIsOpenModalFormOrders(false)
        }}
        header={"Сформированный файл для заказа Samson"}
        onOk={() => {
          downloadRecode(ordersSamsonRef.current, fileName).then((res) => {
            saveAuditFormOrderWB(SHOP_NAME.SAMSON, supplies || [])
          })
        }}
        content={
          <ModalOrderList
            ordersSamson={ordersSamsonRef.current}
            missOrderSamson={missOrdersRef.current}
            info={infoRef.current || []}
          />
        }
        size="l"
        okContent="Скачать"
      />
    </div>
  )
}

type ModalOrderListProps = {
  ordersSamson: RecodeForOrderSamson[]
  missOrderSamson: MissOrderSamson[]
  info: {
    name: string
    value: string
    count: number
    date: string
  }[]
}

export const ModalOrderList = ({
  missOrderSamson,
  info,
}: ModalOrderListProps) => {
  const samsonColumns: DataTableColumn<MissOrderSamson>[] = [
    { key: "goodCode", header: "Артикул продавца" },
    { key: "nmId", header: "Артикул WB" },
  ]

  return (
    <div>
      {(info?.length && (
        <div style={{ backgroundColor: "var(--colors-warning300)" }}>
          <b>Для следующих поставок уже был сформирован заказ:</b>
          <ol>
            {info.map((item) => (
              <li key={item?.value}>
                <b>{item?.name}</b>, {item?.count} раз(а),{" "}
                {new Date(item?.date).toLocaleString()}
              </li>
            ))}
          </ol>
        </div>
      )) ||
        null}
      <label>Артикулы, которые не найдены в перекодировке</label>
      <DataTable
        columns={samsonColumns}
        data={missOrderSamson ?? []}
        rowKey={(_el, i) => "order-list-" + i}
      />
    </div>
  )
}
